import { Component, OnInit } from '@angular/core';
import { CookieService } from '../Services/cookie';
import { Subject } from "rxjs";
import { TicketService } from '../Services/ticket.service';
import { Router } from '@angular/router';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { AccountService } from '../Services/account.service';
import { BranchService } from '../Services/branch.service';

@Component({
  selector: 'app-branch-ticket-issued',
  templateUrl: './branch-ticket-issued.component.html',
  standalone:false,
  styleUrls: ['./branch-ticket-issued.component.scss']
})
export class BranchTicketIssuedComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  cpr: string;
  BranchName: string;
  BranchId: string;
  ServiceId: string;
  ServiceName: string;
  IssueTicket: any;
  branchOpen: boolean;
  Cuswait: string;
  estimatedWaitTime: string;
  userTicketId: any;
  SkipQue: string;
  CheckVstStatus: any;
  Branchdetail: any;

  constructor(private tick: TicketService,private toast:ToastrService, private BranchService: BranchService, public commonP: CommonService, public _router: Router,private account:AccountService, public auth: AuthService, private cookieService: CookieService, private translate:TranslateService) { }

  async ngOnInit(): Promise<any> {

    this.commonP.presentLoading();

    this.cpr = await this.cookieService.get("tempValue", true);
    
    let S = await this.cookieService.get("skipque", false);
    if (S) {
      this.SkipQue = S;

    }

    this.auth.accessToken = await this.commonP.Get("token");

    let BN = await this.cookieService.get("BranchName", false);
    if (BN) {
      this.BranchName = BN;

    }
    let BI = await this.cookieService.get("BranchId", false);
    if (BI) {
      this.BranchId = BI;

    }
    let SI = await this.cookieService.get("ServiceId", false);
    if (SI) {
      this.ServiceId = SI;

    }
    let SN = await this.cookieService.get("ServiceName", false);
    if (SN) {
      this.ServiceName = SN;

    }
    let BR = await this.cookieService.get("branchOpen", false);
    if (BR) {
      this.branchOpen = JSON.parse(BR);

    } 
    let CW = await this.cookieService.get("Cuswait", false);
    if (CW) {
      this.Cuswait = CW;

    } 
    let ES = await this.cookieService.get("estimatedWaitTime", false);
    if (ES) {
      this.estimatedWaitTime = ES;

    }

    if(this.SkipQue == "CheckStatus"){

      let body = {
        "UniqueId": this.commonP.Guid(),
        "CPR": this.cpr,
        "UserTicketId": this.account?.getDashboardDetail?.userTicketId,
        
      }
      console.log("datahere",body);
      
      this.tick.CheckVisitStatus(body,this.auth.accessToken).then((data: any) => {

        if (data?.response?.code == 1) {

          this.CheckVstStatus = data.response.content;
          this.userTicketId = this.CheckVstStatus.userTicketId;

           this.BranchList();
          console.log("CheckVstStatusResponse", this.CheckVstStatus);
          this.commonP.hideLoading();
        }
        else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "OK", this._router, data);
        }
      })

    }
    else{
      let body = {
        "UniqueId": this.commonP.Guid(),
        "CPR": this.cpr,
        "branchID": this.BranchId,
        "branchName": this.BranchName,
        "serviceID": this.ServiceId,
        "serviceName": this.ServiceName,
      }
      this.tick.IssueTicket(body, this.auth.accessToken).then((data: any) => {

        if (data?.response?.code == 1) {

          this.IssueTicket = data.response.content;
          this.userTicketId = this.IssueTicket.userTicketId;

          console.log("IssueTicketResponse", this.IssueTicket);
          this.commonP.hideLoading();
        }
        else {
          this.commonP.hideLoading();
          this.commonP.ParseErrorAlert("", "OK", this._router, data);
        }
      })
    }
   
  }

  showModal(num) {
    this.modalObservable.next(num);
  }

  Delete(){
    this.commonP.presentLoading();
    let body = {
      UniqueId: this.commonP.Guid(),
      CPR: this.cpr,
      UserTicketId:this.userTicketId 
    }
    this.tick.DeleteTicket(body,this.auth.accessToken).then((res:any)=>{
      if(res?.response?.code == 1){
      this.toast.success("You have successfully cancel your Ticket","Status Saved");
      // let key = this.cookieService.generateKey();
      this.cookieService.set("TicketIssue","TicketIssue",true);
      this._router.navigateByUrl("/Dashboard");
      this.commonP.hideLoading();
      }
      else{
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert("","OK",this._router,res);
      }
    })
  }






  async BranchList(){

    let body = {
      UniqueId: this.commonP.Guid(),
      CPR: this.cpr,
      longitude: "108.033",
      latitude: "12.6845983",
      radius: "2147483647"
    }
    this.tick.BranchesListDetails(body, this.auth.accessToken).then((data: any) => {    
        if (data?.response?.code == 1) {
     let B = [...data.response.content.list];
     console.log('this.BranchLocationList',B);
      this.Branchdetail = B.filter( x=> x.name == this.CheckVstStatus.branchName );
      console.log('this.BranchLocationList', this.Branchdetail);
        this.commonP.hideLoading();


      }
      else {
        this.commonP.hideLoading();
        this.commonP.ParseErrorAlert('', '', this._router, data);

      }



    });
  }

}
